var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00445 14.6357C11.4409 14.6357 14.2267 11.8499 14.2267 8.41351C14.2267 4.97707 11.4409 2.19128 8.00445 2.19128C4.56801 2.19128 1.78223 4.97707 1.78223 8.41351C1.78223 11.8499 4.56801 14.6357 8.00445 14.6357Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46973 8.715C7.46973 9.00924 7.71374 9.25325 8.00798 9.25325C8.00887 9.25325 8.00976 9.25325 8.01065 9.25324C8.01274 9.25327 8.01484 9.25328 8.01694 9.25328L11.6053 9.25328C11.8995 9.25328 12.1436 9.00928 12.1436 8.71503C12.1436 8.42078 11.8995 8.17678 11.6053 8.17678L8.54624 8.17677V5.12663C8.54624 4.83239 8.30223 4.58838 8.00798 4.58838C7.71374 4.58838 7.46973 4.83239 7.46973 5.12663V8.715Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55572 2.07333L3.16308 3.45472C2.9975 3.55032 2.75021 3.42791 2.60668 3.1793C2.46314 2.93069 2.47719 2.64911 2.64277 2.55351L5.03541 1.17212C5.20099 1.07652 5.44828 1.19893 5.59181 1.44754C5.73535 1.69615 5.7213 1.97773 5.55572 2.07333Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8486 3.45666L10.4529 2.0735C10.2871 1.97778 10.2693 1.70232 10.4129 1.45371C10.5564 1.2051 10.8074 1.07658 10.9732 1.1723L13.3689 2.55546C13.5347 2.65118 13.5525 2.92664 13.409 3.17525C13.2655 3.42386 13.0144 3.55239 12.8486 3.45666Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSchedule);
export default __webpack_public_path__ + "static/media/add_schedule.c6ddd57c.svg";
export { ForwardRef as ReactComponent };